import React, { useState, useEffect } from "react";
import { InsertDriveFile, Image, PictureAsPdf, Audiotrack, Movie } from '@mui/icons-material';
import OpaqueLoading from "./opaqueLoading/opaqueLoading";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import Add from "@mui/icons-material/Add";
import { Box, TextField, Typography, Autocomplete, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Card, CardContent, Button, Dialog, DialogTitle, DialogContent, DialogActions, InputLabel, MenuItem, Select, Grid, Checkbox, Stack } from "@mui/material";
const OrderForm = ({ payload, closePopup, editData, editMode, getSeriesCategory }) => {
  const [distributor, setDistributor] = useState("");
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
  const [stockist, setStockist] = useState(null);
  const [warehouse, setWarehouse] = useState(null);
  const [warehouses, setWarehouses] = useState([]);
  const [transporter, setTransporter] = useState("");
  const [attachments, setAttachment] = useState("")
  const [shippingAddress, setShippingAddress] = useState("School");
  const [contactData, setContactData] = useState({ School: {}, Distributor: {}, Stockist: {} })
  const [remark, setRemark] = useState("");
  const [orderRemark, setOrderRemark] = useState("");
  const [updateRemark, setUpdateRemark] = useState()
  const [consentPerson, setConsentPerson] = useState("");
  const [otpOpen, setOtpOpen] = useState(false);
  const [otp, setOtp] = useState('')
  const [filteredTransporter, setFilteredTransporter] = useState([payload.transporter])
  const [sv, setSv] = useState(false);
  const [otherMobile, setOtherMobile] = useState("");
  const [otpMobile, setOtpMobile] = useState("");
  const [distributors, setDistributors] = useState([]);
  const [stockists, setStockists] = useState([]);
  const [loading, setLoading] = useState(false);
  const [transporters, setTransporters] = useState([]);
  const [shippingOptions, setShippingOptions] = useState(["School", "Distributor", "Stockist"]);
  const [remarks, setRemarks] = useState([]);
  // const [consentPersons,setConsentPersons] = useState(["School", "Distributor", "Stockist"]);
  const [consentPersons, setConsentPersons] = useState(["School", "Distributor"]);
  const [files, setFiles] = useState([]);
  const [open, setOpen] = useState(false);
  const [specimenDate, setSpecimenDate] = useState("");
  const [isVerified, setIsVerified] = useState(true);
  const [isDiscountAdjustment, setIsDiscountAdjustment] = useState(false);
  const [openSeriesDiscount, setOpenSeriesDiscount] = useState(false);
  const [seriesDiscountData, setSeriesDiscountData] = useState([]);
  const [specimenContactPerson, setSpecimenContactPerson] = useState("");
  const [specimenMessageOption, setSpecimenMessageOption] = useState("registered");
  const [stockistDiscount, setStockistDiscount] = useState(0);
  const [distributorType, setDistributorType] = useState("");
  const [form, setForm] = useState({
    preferredDistributorName: "",
    preferredDistributorPincode: "",
    preferredDistributorState: "",
    preferredDistributorDistrict: "",
    // preferredDistributorCity:"",
    preferredDistributorContactPersonName : "",
    preferredDistributorConsentPersonRole :"",
    preferredDistributorConsentPersonNumber :"",
    preferredDistributorEmail:"",
    preferredDistributorAddress:""
  })
  const [contactPersonRole, setContactPersonRole] = useState([]);


  const formatDateLocal = (d) => {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }
  const today = new Date();
  const specimenMinDate = formatDateLocal(today);
  const specimenMaxDate = formatDateLocal(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 180));

  const handleFileChange = (event) => {
    setFiles([...event.target.files]);
    setOpen(true);
  };

  const getFilePreview = (file) => {
    if (file.type.startsWith('image/')) {
      return <img src={URL.createObjectURL(file)} alt={file.name} style={{ maxWidth: '100%', height: '100px' }} />;
    } else {
      return <InsertDriveFileIcon style={{ fontSize: 50, height: "100px", }} />;
    }
  };

  const getContactPersonRole = async (data) => {
    try {
      setLoading(true)
      const results = await window.Platform.database.getContactPersonRole();
      if (results?.status) {
        setLoading(false);
        window.NotificationUtils.showWarning("Something Went Wrong");
      }
      else {
        setContactPersonRole(results.data2)
        setLoading(false)
      }
    }
    catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  const handleUpload = async () => {
    const formData = new FormData();
    files.forEach((file, index) => {
      formData.append(`files`, file);
    });

    try {
      const response = await window.Platform.database.uploadMultipleImages(formData);
      console.log(response);
      if (response) {
        const result = await response
        console.log(result)
        let temp = [...attachments]
        result.data.files.forEach((ele) => {
          console.log("Da")
          temp.push(ele)
        });
        setAttachment(temp)

        setOpen(false);
      } else {
        alert('Failed to upload files.');
      }
    } catch (error) {
      console.error('Upload error:', error);
      alert('Error uploading files.');
    }
  };

  const fetchWarehouse = async (distru, s) => {
    try {
      const response = await window.Platform.database.getWarehouseinPicklist({});
      if (response && response.data) {
        setWarehouses(response.data);
        fetchTransporter(distru, s)
      } else {
        throw new Error("Failed to load warehouses");
      }
    } catch (error) {
      console.error("Error fetching warehouses:", error);
    }
  };

  function initisalise() {
    let temp = { School: {}, Distributor: {}, Stockist: {} }
    temp['School']['phone'] = payload.mobileNo
    temp['School']['email'] = payload.email
    temp['School']['address'] = payload.address
    temp['School']['id'] = payload.partyId
    temp['School']['addId'] = payload.addressId
    setContactData(temp)
  }

  const fetchDistributor = async () => {
    setLoading(true);
    const body = { ownerId: payload.ownerId };
    try {
      // const response = await window.Platform.database.getAllDistri(body);
      const response = await window.Platform.database.getAllOnbordedDistributors(body);
      if (response && response.data) {
        const data = response.data;
        setDistributors(data)
        if (payload.partyType == 'P6E9TGXewd') {
          setDistributor(payload?.partyId);
          setConsentPerson(["Distributor", "Stockist"])
          setShippingOptions(["Distributor", "Stockist"])
          setShippingAddress("Distributor")
          setConsentPerson("Distributor")
        }
        fetchRemarks()
        fetchStockist(data)
        setLoading(false);
      } else {
        setLoading(false);
        throw new Error("Failed to load distributors");
      }
    } catch (error) {
      console.error("Error fetching distributors:", error);
      setLoading(false);
    }
  };

  const getOtpConsentValue = () => {
    if (!isVerified) return "";
    
    // If schoolPreferred distributor, use preferred distributor contact number
    if (distributorType === "schoolPreferred") {
      const phone = form?.preferredDistributorConsentPersonNumber;
      if (!phone) return "";
      return `Preferred Distributor (${phone})`;
    }
    
    const person = specimenContactPerson || consentPerson || "";
    if (specimenMessageOption === "other") {
      if (!otherMobile) return "";
      return person ? `${person} (${otherMobile})` : otherMobile;
    }
    const phone = contactData?.[person]?.phone;
    if (!phone) return "";
    return `${person} (${phone})`;
  };

  async function order(saveLater) {
    var body = payload;
    body['stockistDiscount'] = stockistDiscount;
    body['stockistId'] = stockist;
    body['distributorId'] = distributor;
    body['transport'] = transporter;
    body['mobileNo'] = contactData[shippingAddress]['id'];
    body['email'] = contactData[shippingAddress]['email'];
    body['address'] = contactData[shippingAddress]['addId'];
    // body['otpConsent'] = consentPerson + `(${contactData[consentPerson]['phone']})`;
    body['attachment'] = attachments || editData?.attachment;
    body['saveLater'] = saveLater ? 1 : 0
    body['remark'] = remark;
    body['order_remark'] = orderRemark;
    body['warehouse'] = warehouse;
    body['attachment'] = attachments || editData?.attachment;
    body['date'] = specimenDate ? Math.floor(new Date(specimenDate).getTime() / 1000) : Math.floor(Date.now() / 1000);
    body['otp_need'] = isVerified;
    body['distributorType'] = distributorType;
    body['form'] = form;
    const otpConsent = getOtpConsentValue();
    if (isVerified && !otpConsent) {
      alert("OTP consent information is missing");
      return;
    }
    body['otpConsent'] = otpConsent;
    console.log(payload, "payload>>>>", body, "Payload to create order");
    // return;

    try {
      const response = await window.Platform.database.createOrder(body);

      if (response && !response.status) {
        closePopup()
      } else {
        throw new Error("Failed to load orders");
      }
    } catch (error) {
      console.error("Error fetching distributors:", error);
    }
  }
console.log(payload,"payload<<<<<<<<<<<<<<<<<<<<<<<<<<");
  async function updateOrder() {
    var body = { ...payload };
    body['stockistDiscount'] = stockistDiscount;
    body['stockistId'] = stockist;
    body['orderId'] = editData.orderId
    body['distributorId'] = distributor;
    body['transport'] = transporter;
    // Use Unix timestamp (seconds)
    // body['date'] = specimenDate ? Math.floor(new Date(specimenDate).getTime() / 1000) : Math.floor(Date.now() / 1000);
    body["date"] = specimenDate
      ? Math.floor(new Date(specimenDate).getTime() / 1000)
      : Math.floor(Date.now() / 1000);
    // body['date'] = Math.floor(Date.now() / 1000)
    body['mobileNo'] = contactData[shippingAddress]['id'];
    body['email'] = contactData[shippingAddress]['email'];
    body['address'] = contactData[shippingAddress]['addId'];
    body['approvalStatus'] = editData.approvalStatus
    body['attachment'] = editData.attachment;
    body['remark'] = remark;
    body['order_remark'] = orderRemark;
    // body['seriesDiscount'] = body?.seriesDiscount || editData?.seriesDiscount || "";
    body['warehouse'] = warehouse;
    body['attachment'] = attachments || editData?.attachment
    body['updateRemark'] = updateRemark
    body['soID'] = editData.so_id
    body['otp_need'] = editData?.isVerified;
    body['distributorType'] = distributorType;
    body['form'] = form;
    const otpConsent = getOtpConsentValue();

    if (isVerified && !otpConsent) {
      alert("OTP consent information is missing");
      return;
    }
    body['otpConsent'] = otpConsent;
    console.log(payload, "payload>>>>", body, "Payload to Update order");
    // return;

    try {
      const response = await window.Platform.database.updateOrderDetails(body);
      if (response && !response.status) {
        closePopup()
      } else {
        throw new Error("Failed to load orders");
      }
    } catch (error) {
      console.error("Error fetching distributors:", error);
    }
  }

  // async function verifyOtp() {
  //   const body = { mobile: contactData[consentPerson]['phone'], otp: otp };
  //   try {
  //     const response = await window.Platform.database.verifyOtp(body);
  //     if (response && !response.status) {
  //       console.log(response)
  //       order(sv)
  //     } else {
  //       throw new Error("Failed to load orders");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching distributors:", error);
  //   }
  // };
  console.log(editData, "edit Dataasonasnasonasadnjasnasdjnasn")
  async function verifyOtp() {
    const body = {
      mobile: otpMobile, // SAME mobile as sendOtp
      otp: otp
    };
    try {
      const response = await window.Platform.database.verifyOtp(body);
      if (response && !response.status) {
        if (editMode) {
          updateOrder();
        } else {
          order(sv);
        }
        // order(sv);
        setOtpOpen(false);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const fetchTransporter = async (d, s) => {
    const body = {};
    try {
      const response = await window.Platform.database.getTransporters(body);

      if (response && response.data) {
        const data = response.data;

        setTransporters(data);
        if (editMode) {
          setTimeout(() => {
            editPrevious(d, s)
          }, 200)
        }
      } else {
        throw new Error("Failed to load transporters");
      }
    } catch (error) {
      console.error("Error fetching transporters:", error);
    }
  };

  function editPrevious(d, s) {
    setDistributor(editData?.distributorIDforSchool ? editData?.distributorIDforSchool : form?.preferredDistributorConsentPersonNumber)
    setWarehouse(editData?.warehouse)
    setStockist(editData?.stockistId)
    let a = editData?.distributorIDforSchool
    let selected = d.filter((ele) => {
      return ele.distributorID == a
    })[0];
    // let b = editData?.stockistId
    // let selectedS = s.filter((ele) => {
    //   return ele.sto == b.stockistID
    // })[0];

    let tempContactData = { School: {}, Distributor: {}, Stockist: {} }
    let fil = [payload.transporter]
    fil.push(selected?.transporterId)

    tempContactData['Distributor']['phone'] = selected?.makerContact
    tempContactData['Distributor']['email'] = selected?.email
    tempContactData['Distributor']['address'] = formatAddress(selected ? selected : {})
    tempContactData['Distributor']['id'] = selected?.distributorID
    tempContactData['Distributor']['addId'] = selected?.addressId
    tempContactData['School']['phone'] = payload.mobileNo
    tempContactData['School']['email'] = payload.email
    tempContactData['School']['address'] = payload.address
    tempContactData['School']['id'] = payload.partyId
    tempContactData['School']['addId'] = payload.addressId
    // tempContactData['Stockist']['phone'] = selectedS?.makerContact
    // tempContactData['Stockist']['email'] = selectedS?.email
    // tempContactData['Stockist']['address'] = formatAddress(selectedS ? selected : {})
    // tempContactData['Stockist']['id'] = selectedS.stockistID
    // tempContactData['Stockist']['addId'] = selectedS.addressId
    setFilteredTransporter(fil)
    setContactData(tempContactData)
    setTransporter(editData?.Transport)
    setOrderRemark(editData?.order_remark)
    setUpdateRemark(editData?.updateRemark)
    if(payload?.orderType == "Specimen"){
      setRemark(editData?.order_remark)
    }
    else{
      setRemark(editData?.remark)
    }
  }
  const fetchRemarks = async () => {
    const body = {};
    try {
      const response = await window.Platform.database.getRemarkInPicklist(body);
      if (response && response.data) {
        setRemarks(response.data);
      } else {
        throw new Error("Failed to load remarks");
      }
    } catch (error) {
      console.error("Error fetching remarks:", error);
    }
  };

  const fetchStockist = async (distru) => {
    const body = { pageNumber: 0 };
    try {
      const response = await window.Platform.database.getStockistAll(body);
      if (response && response.data) {
        setStockists(response.data);
        fetchWarehouse(distru, response.data)
      } else {
        throw new Error("Failed to load orders");
      }
    } catch (error) {
      console.error("Error fetching stockists:", error);
    }
  };

  const formatDateForInput = (dateValue) => {
    if (!dateValue) return "";
    let d;
    if (typeof dateValue === "string") {
      d = new Date(dateValue);
    } else if (typeof dateValue === "number") {
      d = new Date(dateValue * 1000);
    }
    if (!d || isNaN(d.getTime())) return "";
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };
useEffect(() => {
  if (editMode && hasAdditionalDiscount(editData?.additionalDiscount)) {
    setIsDiscountAdjustment(true);
  }
    setOrderRemark(editData?.order_remark  || "")
    setUpdateRemark(editData?.updateRemark || "")
}, [editMode, editData]);


  useEffect(() => {
    if (editMode) {
      setConsentPersons(["School", "Distributor", "Stockist"]);
    } else {
      setConsentPersons(["School", "Distributor"]);
    }
  }, [editMode]);

  useEffect(() => {
    if (!editMode && specimenContactPerson === "Stockist") {
      setSpecimenContactPerson("");
    }
  }, [editMode]);


  useEffect(() => {
    if (editMode && editData) {
      setIsVerified(!!editData?.otp_need);

      // Optional: if you store otpConsent like "School (9876543210)"
      if (editData?.otpConsent) {
        setSpecimenContactPerson(
          editData.otpConsent.split("(")[0]?.trim() || ""
        );
      }
      if (editData?.distributorType) {
        setDistributorType(editData.distributorType);
      }

      if (editData?.form) {
        const parsedForm = typeof editData.form === 'string'
          ? (function () { try { return JSON.parse(editData.form); } catch { return {}; } })()
          : editData.form;
        setForm(prev => ({ ...prev, ...parsedForm }));
      } else {
        const mapped = {};
        if (editData?.distributorNameforSchool) mapped.preferredDistributorName = editData.distributorNameforSchool;
        if (editData?.preferredDistributorPincode) mapped.preferredDistributorPincode = editData.preferredDistributorPincode;
        if (editData?.preferredDistributorState) mapped.preferredDistributorState = editData.preferredDistributorState;
        if (editData?.preferredDistributorDistrict) mapped.preferredDistributorDistrict = editData.preferredDistributorDistrict;
        if (editData?.preferredDistributorContactPersonName) mapped.preferredDistributorContactPersonName = editData.preferredDistributorContactPersonName;
        if (editData?.preferredDistributorConsentPersonRole) mapped.preferredDistributorConsentPersonRole = editData.preferredDistributorConsentPersonRole;
        if (editData?.preferredDistributorConsentPersonNumber) mapped.preferredDistributorConsentPersonNumber = editData.preferredDistributorConsentPersonNumber;
        if (editData?.preferredDistributorEmail) mapped.preferredDistributorEmail = editData.preferredDistributorEmail;
        if (editData?.preferredDistributorAddress) mapped.preferredDistributorAddress = editData.preferredDistributorAddress;
        if (Object.keys(mapped).length) setForm(prev => ({ ...prev, ...mapped }));
      }
    }
  }, [editMode, editData]);

  useEffect(() => {
    if (editData?.date) {
      setSpecimenDate(formatDateForInput(editData.date));
    }
  }, [editData]);

  useEffect(() => {
    getContactPersonRole();
    initisalise()
    fetchDistributor()
  }, [])

  useEffect(() => {
    if (!isVerified) {
      setSpecimenContactPerson("");
      setSpecimenMessageOption("registered");
      setOtherMobile("");
      setOtp("");
      setOtpMobile("");
    }
  }, [isVerified]);

  function formatAddress(addressData) {
    let addressLine1 = addressData['AddressLine1'] ?? '';
    let addressLine2 = addressData['AddressLine2'] ?? '';
    let state = addressData['State'] ?? '';
    let pincode = addressData['Pincode'] ?? '';
    let addressParts = [
      addressLine1,
      addressLine2 ? addressLine2 : "",
      state ? state : "",
      pincode ? pincode : "",
    ];
    return addressParts.join(', ');
  }

  function selectDistributor(value, op) {
    setDistributor(value)

    let a = value

    let selected = distributors.filter((ele) => {
      return ele.distributorID == a
    })[0];
    let temp = { ...contactData }
    let fil = [...filteredTransporter]
    fil.push(selected?.transporterId)

    temp['Distributor']['phone'] = selected?.makerContact
    temp['Distributor']['email'] = selected?.email
    temp['Distributor']['address'] = formatAddress(selected ? selected : {})
    temp['Distributor']['id'] = value
    temp['Distributor']['addId'] = selected.addressId
    setFilteredTransporter(fil)
    setContactData(temp)
  }

  function selectStockist(value) {
    setStockist(value)
    let a = value
    let selected = stockists.filter((ele) => {
      return ele.stockistID == a
    })[0];
    let temp = { ...contactData }
    let fil = [...filteredTransporter]
    fil.push(selected.transporterId)

    temp['Stockist']['phone'] = selected.makerContact
    temp['Stockist']['email'] = selected.email
    temp['Stockist']['address'] = formatAddress(selected)
    temp['Stockist']['id'] = value
    temp['Stockist']['addId'] = selected.addressId
    setFilteredTransporter(fil.filter((ele, index) => { return ele && fil.indexOf(ele) == index }))
    setContactData(temp)
  }

  function getNameByID(t) {
    return transporters.filter(ele => ele.transporterId == t)[0]?.transporter_name
  }

  const getOtpMobile = () => {
    if (!isVerified) return "";
    
    if (distributorType === "schoolPreferred") {
      return form?.preferredDistributorConsentPersonNumber || "";
    }
    
    if (specimenMessageOption === "registered") {
      const person = specimenContactPerson || consentPerson || "";
      const phoneFromData = contactData?.[person]?.phone;
      if (phoneFromData) return phoneFromData;
      if (person === "Distributor") {
        const sel = distributors.find(d => d.distributorID == distributor);
        if (sel) return sel.makerContact || sel?.makerContact || "";
      }
      if (person === "Stockist") {
        const sel = stockists.find(s => s.stockistID == stockist);
        if (sel) return sel.makerContact || sel?.makerContact || "";
      }
      return "";
    }
    if (specimenMessageOption === "other") {
      return otherMobile;
    }
    return "";
  };

  const isPreferredDistributorFormInvalid = () => {
  return (
    !form.preferredDistributorName ||
    !form.preferredDistributorPincode ||
    !form.preferredDistributorState ||
    !form.preferredDistributorDistrict ||
    // !form.preferredDistributorCity ||
    !form.preferredDistributorContactPersonName ||
    !form.preferredDistributorConsentPersonRole ||
    !form.preferredDistributorConsentPersonNumber ||
    !form.preferredDistributorEmail || 
    !form.preferredDistributorAddress
  );
};


  async function proceedToOrder(flag) {
   if(payload?.orderType != "Specimen"){
     if(!distributorType){
      alert("Please Select Distributor Type");
      return;
    }
     if(payload?.orderProcess != "upload" && payload?.orderType?.toLowerCase() != "specimen" && (distributorType == "schoolPreferred" && isPreferredDistributorFormInvalid())) {
        alert(" Please fill form correctly ");
        return;
      }
      if(distributorType == "onboarded" && !distributor){
        alert(" Please Select Distributor ");
        return;
      }
   }
    setSv(flag);
    if (editMode) {
      if (!updateRemark || updateRemark === "" || updateRemark === undefined) {
        alert("Please enter update remark");
        return;
      }
      else if (updateRemark?.length < 20) {
        alert("Update remark should be at least 20 characters long");
        return;
      }
     
      if (!isVerified) {
        updateOrder();
        return;
      }
      const mobile = getOtpMobile();
      if (!mobile) {
        alert("Please enter valid mobile number");
        return;
      }
      setOtpMobile(mobile);
      const body = { mobile };
      try {
        const response = await window.Platform.database.sendOtp(body);
        if (response && !response.status) {
          setOtpOpen(true);
        }
        else {
          window.NotificationUtils.showError(response?.message, mobile || "Failed to send OTP. Please try again.");
        }
      } catch (error) {
        console.error(error);
        window.NotificationUtils.showError(mobile, "Failed to send OTP. Please try again.");

      }
      // updateOrder();
      return;
    }
    if(payload?.orderType == "Specimen") {
      if(remark.trim() === ""){
      alert("Please enter remark for specimen order");
      return;
      }
      else if(remark.trim().length < 20){
      alert("Remark for specimen order should be at least 20 characters long");
      return;
      }
    }
    else{
      if(orderRemark === "" || orderRemark === undefined){
      alert("Please enter order remark");
      return;
    }
    else if(orderRemark.length < 20){
      alert("Order remark should be at least 20 characters long");
      return;
    }
    }
      if(payload?.orderProcess != "upload" && payload?.orderType?.toLowerCase() != "specimen" && attachments == "") {
      alert("Please upload attachment(s) before placing the order.");
      return;
    }
    if (!isVerified) {
      order(flag);
      return;
    }
    const mobile = getOtpMobile();
    if (!mobile) {
      alert("Please enter valid mobile number");
      return;
    }
    setOtpMobile(mobile);
    const body = { mobile };
    try {
      const response = await window.Platform.database.sendOtp(body);
      if (response && !response.status) {
        setOtpOpen(true);
      }
      else {
        window.NotificationUtils.showError(response?.message, mobile || "Failed to send OTP. Please try again.");
      }
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError(mobile, "Failed to send OTP. Please try again.");
    }
  }

  function handleSeriesDiscountChange(seriesId, value) {
    const entered = Number(value) || 0;

    setSeriesDiscountData(prev =>
      prev.map(item => {
        if (item.seriesId !== seriesId) return item;

        if (entered > item.remaining) {
          window.NotificationUtils.showError(
            `You already gave ${item.alreadyGiven}%, remaining is ${item.remaining}% for ${item.seriesName}. Overall limit is ${item.maxAllowed}%`
          );
          return item;
        }

        return {
          ...item,
          additional: entered
        };
      })
    );
  }

  // function handleAdditionalDiscount() {
  //   console.log(payload, "payload<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<", editData, "eidtData<<<<<<<<<<<<<<<<<<<<<<<<")
  //   const preparedData = getSeriesCategory
  //     .filter(s => payload.seriesDiscount?.[s.seriesTableId] !== undefined)
  //     .map(series => {
  //       const alreadyGiven = payload.seriesDiscount[series.seriesTableId] || 0;
  //       const maxAllowed = Number(series.maxDiscount) || 0;

  //       return {
  //         seriesId: series.seriesTableId,
  //         seriesName: series.seriesName,
  //         alreadyGiven,
  //         maxAllowed,
  //         remaining: Math.max(maxAllowed - alreadyGiven, 0),
  //         additional: 0
  //       };
  //     });
  //   setSeriesDiscountData(preparedData);
  //   setOpenSeriesDiscount(true);
  // }
//     const parseAdditionalDiscount = (val) => {
//   if (!val) return {};
//   if (typeof val === "object") return val;
//   try {
//     return JSON.parse(val);
//   } catch (e) {
//     return {};
//   }
// };
const parseAdditionalDiscount = (val) => {
  if (!val) return {};
  try {
    return typeof val === "string" ? JSON.parse(val) : val;
  } catch {
    return {};
  }
};

const hasAdditionalDiscount = (val) => {
  const parsed = parseAdditionalDiscount(val);
  return Object.keys(parsed).length > 0;
};


  function handleAdditionalDiscount() {
  const existingAdditional = editMode
    ? parseAdditionalDiscount(editData?.additionalDiscount)
    : {};

  const preparedData = getSeriesCategory
    .filter(s => payload.seriesDiscount?.[s.seriesTableId] !== undefined)
    .map(series => {
      const alreadyGiven = payload.seriesDiscount[series.seriesTableId] || 0;
      const maxAllowed = Number(series.maxDiscount) || 0;

      return {
        seriesId: series.seriesTableId,
        seriesName: series.seriesName,
        alreadyGiven,
        maxAllowed,
        remaining: Math.max(maxAllowed - alreadyGiven, 0),
        // ✅ PREFILL FROM EDIT DATA
        additional: existingAdditional?.[series.seriesTableId] || 0
      };
    });

  setSeriesDiscountData(preparedData);
  setOpenSeriesDiscount(true); // opens ONLY on click
}


  function applyAdditionalDiscount() {
    const additionalDiscount = {};

    seriesDiscountData.forEach(item => {
      if (item.additional > 0) {
        additionalDiscount[item.seriesId] = item.additional;
      }
    });

    payload.additionalDiscount = additionalDiscount;

    setOpenSeriesDiscount(false);
  }

  // const getStockistHelperText = () => {
  //   if (!payload?.totalAmount || !stockistDiscount) {
  //     return "Enter discount percentage";
  //   }

  //   const discountValue =
  //     (payload.totalAmount * stockistDiscount) / 100;

  //   return `₹${discountValue.toFixed(2)} will be discounted from total order value`;
  // };

    const parsedAttachments = React.useMemo(() => {
    if (!editData?.attachment) return [];
  
    // If already array, return as is
    if (Array.isArray(editData?.attachment)) return editData?.attachment;
  
    // If string, parse JSON
    if (typeof editData?.attachment === "string") {
      try {
        return JSON.parse(editData?.attachment);
      } catch (err) {
        console.error("Invalid attachments JSON", err);
        return [];
      }
    }
  
    return [];
  }, [editData?.attachment]);
  
  const handleImageClick = (file) => {
    const url = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;
    window.open(url, "_blank");
  };

  const handlePdfClick = (file) => {
    const url = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;
    window.open(url, "_blank");
  };

  const downloadFile = async (file) => {
    const url = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;

    try {
      const response = await fetch(url);
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = file.originalName || file.fileName || "download";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Download failed:", err);
    }
  };
  
const changeHandler = (fieldName, value) => {
  setForm((prevForm) => ({
    ...prevForm,
    [fieldName]: value,
  }));
};

 const fetchPinCode = async (pincode) => {
  try {
    setLoading(true);

    const results = await window.Platform.database.fetchPinCode(pincode);

    if (results?.status) {
      window.NotificationUtils.showWarning("Something went wrong");
    } else {
      setForm((prev) => ({
        ...prev,
        preferredDistributorState: results?.data?.[0]?.StateName || "",
        preferredDistributorDistrict: results?.data?.[0]?.District || "",
        // preferredDistributorCity: results?.data?.[0]?.City || "",
      }));
    }
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

console.log(form,"formpreferredDistributorDetails");
  return (
    <Box sx={{ p: 3, maxWidth: 500, mx: "auto" }}>
      {loading && <OpaqueLoading />}
      {payload?.orderType === "Specimen" ? (
        <Box>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
            Specimen Order Details
          </Typography>
          {payload?.orderType === "Specimen" &&
            <>
              <Card sx={{ mt: 2, p: 2, width: '100%' }}  fullWidth maxWidth="sm">
                <FormLabel>Upload Attachments</FormLabel>
                <input type="file" multiple onChange={handleFileChange} />
                <Dialog open={open} onClose={() => setOpen(false)}  fullWidth maxWidth="sm">
                  <DialogTitle>File Preview</DialogTitle>
                  <DialogContent>
                    <Grid container spacing={2}>
                      {files.map((file, index) => (
                        <Grid item xs={6} key={index}>
                          {getFilePreview(file)}
                          <Typography variant="body2" noWrap>{file.name}</Typography>
                        </Grid>
                      ))}
                    </Grid>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button onClick={handleUpload} variant="contained" color="primary">Upload</Button>
                  </DialogActions>
                </Dialog>
              </Card>
            </>
          }
          {editMode && payload?.orderType === "Specimen" &&  <Grid container spacing={3} sx={{ mt: 1 }}>
                {parsedAttachments && parsedAttachments?.map((file, index) => {
                  const isImage = /\.(jpg|jpeg|png|gif)$/i.test(file.fileName);
                  const isPDF = /\.pdf$/i.test(file.fileName);

                  return (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                      <Card
                        elevation={3}
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          borderRadius: 2,
                        }}
                      >
                        {/* Preview */}
                        <Box
                          sx={{
                            height: 160,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#f5f5f5",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            isPDF ? handlePdfClick(file) : handleImageClick(file)
                          }
                        >
                          {isImage ? (
                            <img
                              src={`${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`}
                              alt={file.originalName}
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <InsertDriveFileIcon sx={{ fontSize: 60, color: "#666" }} />
                          )}
                        </Box>

                        {/* File Info */}
                        <CardContent sx={{ p: 1.5 }}>
                          <Typography
                            variant="body2"
                            title={file.originalName}
                            sx={{
                              fontWeight: 500,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {file.originalName}
                          </Typography>
                        </CardContent>

                        {/* Actions */}
                        <Box sx={{ p: 1.5, pt: 0 }}>
                          <Button
                            fullWidth
                            size="small"
                            variant="outlined"
                            onClick={(e) => {
                              e.stopPropagation();
                              downloadFile(file);
                            }}
                          >
                            Download
                          </Button>
                        </Box>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>}
          <TextField
            label="Remark"
            multiline
            rows={3}
            fullWidth
            sx={{ mt: 2 }}
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
          />
          {/* {payload?.orderType === "Specimen" && <TextField
            label="Delivery Date"
            type="date"
            fullWidth
            sx={{ mt: 2 }}
            value={specimenDate}
            onChange={(e) => setSpecimenDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />} */}
            {editMode && <TextField
            label="Update Remark"
            fullWidth
            sx={{ mt: 2 }}
            value={updateRemark}
            onChange={(e) => setUpdateRemark(e.target.value)}
          />}
        </Box>
      ) : (
        <Box style={{width:"100%"}}>
          {/* <FormControl fullWidth className="my-2">
            <InputLabel>{"Select Distributor"}</InputLabel>
            <Select value={distributor} label={"Select Distributor"} disabled={payload.partyType == 'P6E9TGXewd'} onChange={(e) => selectDistributor(e.target.value)}>
              {distributors.map((option, i) => (
                <MenuItem key={i} value={option?.distributorID}>{option?.DistributorName}</MenuItem>
              ))}
            </Select>
          </FormControl> */}
            <FormControl fullWidth className="my-2">
              <InputLabel>Select Distributor Type</InputLabel>
              <Select
                value={distributorType}
                label="Select Distributor Type"
                onChange={(e) => setDistributorType(e.target.value)}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="onboarded">Onboarded Distributor</MenuItem>
                <MenuItem value="schoolPreferred">School Preferred Distributor</MenuItem>
              </Select>
            </FormControl>

            {distributorType === "onboarded"  && (
              <FormControl fullWidth className="my-2">
                <InputLabel>Select Distributor</InputLabel>
                <Select
                  value={distributor}
                  label="Select Distributor"
                  disabled={payload.partyType === "P6E9TGXewd"}
                  onChange={(e) => selectDistributor(e.target.value)}
                >
                  {distributors.map((option, index) => (
                    <MenuItem key={index} value={option?.distributorID}>
                      {option?.DistributorName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) }
             {distributorType == "schoolPreferred" && (
              <>
                <TextField
                required
                  label="Preferred Distributor Name"
                  fullWidth
                  size="small"
                  sx={{ mt: 2 }}
                  value={form?.preferredDistributorName || ""}
                  onChange={(e) =>
                    changeHandler("preferredDistributorName", e.target.value)
                  }
                />
                <TextField
                    sx={{ mt: 2 }}
                    label="Address "
                    fullWidth
                    required
                    size="small"
                    value={form?.preferredDistributorAddress || ""}
                    onChange={(e) => {
                      changeHandler("preferredDistributorAddress", e.target.value);
                    }}
                  />
                  <TextField
                    sx={{ mt: 2 }}
                    label="Pincode"
                    fullWidth
                    required
                    size="small"
                    value={form?.preferredDistributorPincode || ""}
                    onChange={async (e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 6);
                      changeHandler("preferredDistributorPincode", value);
                      if (value.length === 6) {
                        fetchPinCode(value);
                      }
                    }}
                  />
                  <TextField
                  required
                  sx={{ mt: 2 }}
                    label="State"
                    fullWidth
                    size="small"
                    disabled
                    value={form?.preferredDistributorState || ""}
                  />
                  <TextField
                  required
                  sx={{ mt: 2 }}
                    label="District"
                    fullWidth
                    size="small"
                    disabled
                    value={form?.preferredDistributorDistrict || ""}
                  />
                   {/* <TextField
                  sx={{ mt: 2 }}
                    label="City"
                    fullWidth
                    size="small"
                    value={form?.preferredDistributorCity || ""}
                     onChange={(e) =>
                    changeHandler("preferredDistributorCity", e.target.value)
                  }
                  /> */}
                <TextField
                required
                  label="Contact Person Name"
                  fullWidth
                  size="small"
                  sx={{ mt: 2 }}
                  value={form?.preferredDistributorContactPersonName || ""}
                  onChange={(e) =>
                    changeHandler("preferredDistributorContactPersonName", e.target.value)
                  }
                />
                {/* <TextField
                  label="Contact Person Role"
                  fullWidth
                  size="small"
                  sx={{ mt: 2 }}
                  value={form?.preferredDistributorConsentPersonRole || ""}
                  onChange={(e) =>
                    changeHandler("preferredDistributorConsentPersonRole", e.target.value)
                  }
                /> */}
                  <FormControl  fullWidth size="small" sx={{ mt: 2 }}
                            variant="outlined">
                            <InputLabel sx={{ color: "black", fontWeight: "500" }} required>Decision Maker Role</InputLabel>
                            <Select
                            required
                              labelId={`Product`}
                              label="Decision Maker Role"
                              sx={{ color: "black", fontWeight: "500" }}
                              value={form?.preferredDistributorConsentPersonRole || ""}
                              onChange={(e) => changeHandler("preferredDistributorConsentPersonRole", e.target.value)}
                            >
                              {contactPersonRole?.map((option, optionIndex) => (
                                <MenuItem key={option?.contactPersonRoleId} value={option?.contactPersonRoleId} sx={{ color: "black", fontWeight: "500" }}>
                                  {option?.roleName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                <TextField
                required
                  label="Contact Number"
                  fullWidth
                  size="small"
                  sx={{ mt: 2 }}
                  inputProps={{ maxLength: 10 }}
                  value={form?.preferredDistributorConsentPersonNumber || ""}
                  onChange={(e) =>
                    changeHandler(
                      "preferredDistributorConsentPersonNumber",
                      e.target.value.replace(/[^0-9]/g, "")
                    )
                  }
                />
                <TextField
                required
                  label="Email Address"
                  fullWidth
                  size="small"
                  sx={{ mt: 2 }}
                  value={form?.preferredDistributorEmail || ""}
                  onChange={(e) =>
                    changeHandler("preferredDistributorEmail", e.target.value)
                  }
                />
              </>
            )}

          {/* <FormControl fullWidth className="my-2">
              <InputLabel>{"Select Warehouse"}</InputLabel>
              <Select value={warehouse}  label={"Select Warehouse"} onChange={(e)=>setWarehouse(e.target.value)}>
                {warehouses.map((option, i) => (
                  <MenuItem key={i} value={option?.wh_code}>{option?.name}</MenuItem>
                ))}
              </Select>
              </FormControl> */}
          {/* {distributor && stockist && (
        <FormControl sx={{ mt: 2 }} className="my-2">
          <FormLabel>Transporter</FormLabel>
          <RadioGroup
            value={transporter}
            onChange={(e) => setTransporter(e.target.value)}
          >
            {filteredTransporter.map((t) => (
              <FormControlLabel key={t} value={t} control={<Radio />} label={getNameByID(t)} />
            ))}
          </RadioGroup>
        </FormControl>
      )} */}
          {/* <Card sx={{ mt: 2, p: 2 }}>
        <FormControl>
          <FormLabel>Shipping Address</FormLabel>
          <RadioGroup
            value={shippingAddress}
            onChange={(e) => setShippingAddress(e.target.value)}
          >
            {shippingOptions.map((option) => (
              <FormControlLabel key={option} value={option} control={<Radio />} label={option} />
            ))}
          </RadioGroup>
        </FormControl>{console.log(contactData,"contactdata",contactData[shippingAddress],"contactData[shippingAddress]")}
        <TextField label="Address" value={contactData[shippingAddress]['address'] || ""} variant="outlined"  InputLabelProps={{ shrink: true }}  fullWidth sx={{ mt: 1 }} disabled />
        <TextField label="Mobile" fullWidth sx={{ mt: 1 }} variant="outlined"  InputLabelProps={{ shrink: true }}  value={contactData[shippingAddress]['phone'] || ""} disabled/>
        <TextField label="Email" fullWidth sx={{ mt: 1 }} variant="outlined"  InputLabelProps={{ shrink: true }}  value={contactData[shippingAddress]['email'] || ""} disabled/>
      </Card> */}

          {/* <div style={{display:"flex", justifyContent:"center"}}>
         <FormControlLabel
       sx={{color:"#000", fontSize:"15px", fontWeight:"600"}}
          control={
            <Checkbox
              checked={isDiscountAdjustment}
              onChange={(e) => setIsDiscountAdjustment(e.target.checked)}
            />
          }
          label="Discount Adjustment"
        />
      </div> */}
          {/* <FormControlLabel
            control={
              <Checkbox
                checked={isDiscountAdjustment}
                onChange={(e) => setIsDiscountAdjustment(e.target.checked)}
                sx={{
                  color: "#586b7fff",
                  "&.Mui-checked": {
                    color: "#1976d2",
                  },
                }}
              />
            }
            label="Discount Adjustment"
            sx={{
              // border: "1px solid #566676ff",
              borderRadius: "8px",
              px: 2,
              py: 0.8,
              ml: 0,
              backgroundColor: isDiscountAdjustment ? "#e3f2fd" : "#fff",
              cursor: "pointer",
              userSelect: "none",
              width: "100%",
              fontWeight: 600,
              fontSize: "14px",
              color: "#000",
              transition: "all 0.25s ease",
              "&:hover": {
                backgroundColor: "#f5f9ff",
              },
            }}
          />

          {isDiscountAdjustment && (
            <Button
              variant="outlined"
              startIcon={<Add />}
              sx={{
                mt: 1.5,
                borderColor: "#000",
                color: "#000",
                fontWeight: 600,
                textTransform: "none",
                "&:hover": {
                  borderColor: "#000",
                  backgroundColor: "#f5f5f5",
                },
              }}
              onClick={() => handleAdditionalDiscount()}
            >
              Discount Adjustment
            </Button>
          )} */}

          { payload?.orderProcess != "upload" && <Card sx={{ mt: 2, p: 2, width: '100%' }}>
            <FormLabel sx={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>Upload Attachments</FormLabel>
            <input type="file" multiple onChange={handleFileChange} />
            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
              <DialogTitle>File Preview</DialogTitle>
              <DialogContent>
                <Grid container spacing={2}>
                  {files.map((file, index) => (
                    <Grid item xs={6} key={index}>
                      {getFilePreview(file)}
                      <Typography variant="body2" noWrap>{file.name}</Typography>
                    </Grid>
                  ))}
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpen(false)}>Cancel</Button>
                <Button onClick={handleUpload} variant="contained" color="primary">Upload</Button>
              </DialogActions>
            </Dialog>
          </Card>}
          {editMode && payload?.orderProcess != "upload" && <Grid container spacing={3} sx={{ mt: 1 }}>
                {parsedAttachments && parsedAttachments?.map((file, index) => {
                  const isImage = /\.(jpg|jpeg|png|gif)$/i.test(file.fileName);
                  const isPDF = /\.pdf$/i.test(file.fileName);

                  return (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                      <Card
                        elevation={3}
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          borderRadius: 2,
                        }}
                      >
                        {/* Preview */}
                        <Box
                          sx={{
                            height: 160,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#f5f5f5",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            isPDF ? handlePdfClick(file) : handleImageClick(file)
                          }
                        >
                          {isImage ? (
                            <img
                              src={`${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`}
                              alt={file.originalName}
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <InsertDriveFileIcon sx={{ fontSize: 60, color: "#666" }} />
                          )}
                        </Box>

                        {/* File Info */}
                        <CardContent sx={{ p: 1.5 }}>
                          <Typography
                            variant="body2"
                            title={file.originalName}
                            sx={{
                              fontWeight: 500,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {file.originalName}
                          </Typography>
                        </CardContent>

                        {/* Actions */}
                        <Box sx={{ p: 1.5, pt: 0 }}>
                          <Button
                            fullWidth
                            size="small"
                            variant="outlined"
                            onClick={(e) => {
                              e.stopPropagation();
                              downloadFile(file);
                            }}
                          >
                            Download
                          </Button>
                        </Box>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>}
          {editMode && <FormControl fullWidth className="my-2">
            <InputLabel>{"Select Stockist"}</InputLabel>
            <Select value={stockist} label={"Select Stockist"} onChange={(e) => selectStockist(e.target.value)}>
              {stockists.map((option, i) => (
                <MenuItem key={i} value={option?.stockistID}>{option?.StockistName}</MenuItem>
              ))}
            </Select>
          </FormControl>
          }
          {editMode && stockist && (payload?.totalAmount > 0) &&  <Card sx={{ mb: 2, p: 2, backgroundColor: "#f9f9f9" }}>
            {/* <Typography fontWeight={600}>
              Stockist Discount (on Total Price {payload?.totalAmount || ""})
            </Typography> */}

            {/* <TextField
              type="number"
              label="Stockist Discount (%)"
              value={stockistDiscount}
              onChange={(e) => {
                let val = Number(e.target.value) || 0;

                if (val < 0) val = 0;
                if (val > 100) val = 100;

                setStockistDiscount(val);
              }}
              inputProps={{ min: 0, max: 100 }}
              fullWidth
              sx={{ mt: 1 }}
              helperText={getStockistHelperText()}
            /> */}
            {/* <TextField
              type="number"
              label="Stockist Discount (%)"
              value={stockistDiscount}
              onChange={(e) => {
                let val = Number(e.target.value) || 0;

                if (val < 0) val = 0;
                if (val > 100) val = 100;

                setStockistDiscount(val);
              }}
              inputProps={{ min: 0, max: 100 }}
              fullWidth
              sx={{
                mt: 1,
                "& .MuiFormHelperText-root": {
                  color: "#000", // ✅ helper text black
                  fontWeight: 500,
                },
              }}
              helperText={getStockistHelperText()}
            /> */}

            {/* Discounted price */}
            {((payload.totalAmount * stockistDiscount) / 100) > 0 && (
              <Typography
                variant="body2"
                sx={{
                  mt: 0.5,
                  color: "green", // ✅ discounted price green
                  fontWeight: 600,
                }}
              >
                Discounted Price: ₹{(payload.totalAmount * stockistDiscount) / 100}
                {/* Discounted Price: ₹{discountedPrice} */}
              </Typography>
            )}

          </Card>}
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Select Remark</InputLabel>
            <Select value={remark} label="Select Remark" onChange={(e) => setRemark(e.target.value)}>
              { }
              {
                remarks && remarks.map((r) => (
                  <MenuItem key={r.id} value={r.name}>{r?.name}</MenuItem>

                ))}
            </Select>
          </FormControl>
          <TextField
            label="Order Remark"
            fullWidth
            sx={{ mt: 2 }}
            value={orderRemark}
            onChange={(e) => setOrderRemark(e.target.value)}
          />
          <TextField
            label="Delivery Date"
            type="date"
            fullWidth
            sx={{ mt: 2 }}
            value={specimenDate}
            onChange={(e) => setSpecimenDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
          {editMode && <TextField
            label="Update Remark"
            fullWidth
            sx={{ mt: 2 }}
            value={updateRemark}
            onChange={(e) => setUpdateRemark(e.target.value)}
          />}
          {/* {!editMode&&<Card sx={{ mt: 2, p: 2 }}>
        <FormControl>
          <FormLabel>Consent Person</FormLabel>
          <RadioGroup
            value={consentPerson}
            onChange={(e) => setConsentPerson(e.target.value)}
          >
            {consentPersons.map((p) => (
              <FormControlLabel key={p} value={p} control={<Radio />} label={p} />
            ))}
          </RadioGroup>
        </FormControl>
      </Card>} */}
        </Box>
      )}

      <Card sx={{ p: 2, mt: 2, backgroundColor: "#f5f5f5" }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isVerified}
              onChange={(e) => setIsVerified(e.target.checked)}
            />
          }
          label="Verify with code"
        />
        {isVerified && (
          <Box sx={{ mt: 2, pt: 2, borderTop: "1px solid #ddd" }}>
            {/* <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Choose Contact Person</InputLabel>
              <Select
                value={specimenContactPerson}
                label="Choose Contact Person"
                onChange={(e) => setSpecimenContactPerson(e.target.value)}
              >
                <MenuItem key={""} value={""}>Select Contact Person</MenuItem>
                {consentPersons.map((p) => (
                  <MenuItem key={p} value={p}>{p}</MenuItem>
                ))}
              </Select>
            </FormControl> */}
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Choose Contact Person</InputLabel>
              <Select
                value={specimenContactPerson}
                label="Choose Contact Person"
                onChange={(e) => setSpecimenContactPerson(e.target.value)}
              >
                <MenuItem value="">Select Contact Person</MenuItem>
                {consentPersons.map((p) => (
                  <MenuItem key={p} value={p}>{p}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <Card sx={{ p: 2, backgroundColor: "#fff", border: "1px solid #e0e0e0" }}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Send message to:
              </Typography>
              <FormControl component="fieldset">
                <RadioGroup
                  value={specimenMessageOption}
                  onChange={(e) => setSpecimenMessageOption(e.target.value)}
                >
                  <FormControlLabel
                    value="registered"
                    control={<Radio />}
                    label="Registered number"
                  />
                  <FormControlLabel
                    value="other"
                    control={<Radio />}
                    label="Other"
                  />
                </RadioGroup>
              </FormControl>
              {specimenMessageOption === "other" && (
                <TextField
                  label="Enter Phone Number"
                  fullWidth
                  sx={{ mt: 2 }}
                  value={otherMobile}
                  onChange={(e) => setOtherMobile(e.target.value)}
                />
              )}
            </Card>
          </Box>
        )}
      </Card>
      {/* <Button variant="contained" sx={{ mt: 3 }} fullWidth
        disabled={isVerified && (!specimenContactPerson || (specimenMessageOption === "other" && otherMobile.trim() === ""))}
        // disabled={isVerified && !specimenContactPerson}
        onClick={() => proceedToOrder(false)}
      >
        Place Order
      </Button> */}
      {console.log(specimenContactPerson, "specimenContactPerson", otherMobile, "otherMobile")}
      <Button
        variant="contained"
        sx={{ mt: 3 }}
        fullWidth
        disabled={isVerified &&
          (
            (specimenMessageOption.toLowerCase() === "other" && otherMobile.trim() === "") ||
            (specimenMessageOption.toLowerCase() != "other" && (!specimenContactPerson || specimenContactPerson.trim() == ""))
          )}
        onClick={() => proceedToOrder(false)}
      >
        Place Order
      </Button>

      {!editMode && <Button variant="contained" sx={{ mt: 3 }} fullWidth onClick={() => proceedToOrder(true)}>
        Save For Later
      </Button>}
      <Dialog open={otpOpen} onClose={() => setOtpOpen(false)}>
        <DialogTitle>Enter OTP</DialogTitle>
        <DialogContent>
          <TextField fullWidth label="OTP" value={otp} onChange={(e) => setOtp(e.target.value)} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOtpOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={verifyOtp}>Submit</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openSeriesDiscount}
        onClose={() => setOpenSeriesDiscount(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Series Wise Additional Discount</DialogTitle>

        <DialogContent>
          {seriesDiscountData.map(item => (
            <Card key={item.seriesId} sx={{ mb: 2, p: 2 }}>
              <Typography fontWeight={600}>
                {item.seriesName}
              </Typography>

              <Typography variant="body2">
                Already Given: {item.alreadyGiven}%
              </Typography>

              <Typography variant="body2" color="success.main">
                Remaining: {item.remaining}% (Max {item.maxAllowed}%)
              </Typography>

              <TextField
                type="number"
                label="Additional Discount (%)"
                value={item.additional}
                onChange={(e) =>
                  handleSeriesDiscountChange(item.seriesId, e.target.value)
                }
                inputProps={{ min: 0, max: item.remaining }}
                fullWidth
                sx={{ mt: 1 }}
                disabled={item.remaining === 0}
              />
            </Card>
          ))}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenSeriesDiscount(false)}>Cancel</Button>
          <Button variant="contained" onClick={applyAdditionalDiscount}>
            Apply Discount
          </Button>
        </DialogActions>
      </Dialog>

    </Box>

  );
};
export default OrderForm;